<template>
  <div class="mb-6 mt-6 flex w-full">
    <div
      v-if="isMounted"
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto"
    >
      <vx-card class="mb-16 mt-10">
        <div class="vx-card__title mb-4">
          <h4 class="mb-4">{{completed ? 'Cuenta activada' : 'Activar cuenta'}}</h4>
          <p v-if="!completed" >
            Escribe tu nueva contraseña, la cual <strong>debe contener:</strong>
          </p>
        </div>

        <div v-if="!completed" class="vx-row">
          <div class="vx-col md:w-1/2 sm:w-full w-full">
            <p class="mb-5">
              <feather-icon
                :svgClasses="`${colorForCriteria(0)} h-4 w-4`"
                class="p-2"
                :icon="iconForCriteria(0)"
              />Una letra minúscula <br />
              <feather-icon
                :svgClasses="`${colorForCriteria(1)} h-4 w-4`"
                class="p-2"
                :icon="iconForCriteria(1)"
              />Una letra mayúscula <br />
              <feather-icon
                :svgClasses="`${colorForCriteria(2)} h-4 w-4`"
                class="p-2"
                :icon="iconForCriteria(2)"
              />Un número <br />
            </p>
          </div>
          <div class="vx-col md:w-1/2 sm:w-full w-full">
            <p class="mb-5">
              <feather-icon
                :svgClasses="`${colorForCriteria(3)} h-4 w-4`"
                class="p-2"
                :icon="iconForCriteria(3)"
              />Un símbolo <br />
              <feather-icon
                :svgClasses="`${colorForCriteria(4)} h-4 w-4`"
                class="p-2"
                :icon="iconForCriteria(4)"
              />8 caracteres mínimo <br />
              <feather-icon
                :svgClasses="`${colorForCriteria(5)} h-4 w-4`"
                class="p-2"
                :icon="iconForCriteria(5)"
              />Sin letras ni números consecutivos <br />
            </p>
          </div>
        </div>

        <vs-alert v-if="onError && !completed" class="h-full mb-5" color="danger">
          <span>{{ errorMssg }}</span>
        </vs-alert>
        
        <vs-alert v-if="completed"  class="h-full mb-5" color="success">
          <span>{{ successMssgDef }}</span>
        </vs-alert>

        <div v-if="!completed"  class="vx-row">
          <div :class="colClass">
            <label class="vs-input--label">Contraseña *</label>
            <vx-input-group class="w-full">
              <vs-input
                v-model.lazy="model.password"
                v-validate="requiredRules"
                :danger="hasError('password')"
                :danger-text="errorText('password')"
                :success="passwordFieldValid"
                :type="passInputType"
                :placeholder="requiredPlaceholder"
                name="password"
              />

              <template slot="append">
                <div class="append-text btn-addon" style="height: 40px">
                  <vs-button
                    color="dark"
                    @click="togglePassInputType()"
                    icon-pack="feather"
                    :icon="passInputIcon"
                  ></vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
          <div :class="colClass">
            <label class="vs-input--label">Confirma la contraseña *</label>
            <vx-input-group class="w-full">
              <vs-input
                onpaste="return false;"
                v-model.lazy="model.confirmed_password"
                v-validate="requiredRules"
                :danger="hasError('confirmed_password')"
                :danger-text="errorText('confirmed_password')"
                :success="confirmPasswordFieldValid"
                :type="confirmPassInputType"
                :placeholder="requiredPlaceholder"
                name="confirmed_password"
              />

              <template slot="append">
                <div class="append-text btn-addon" style="height: 40px">
                  <vs-button
                    color="dark"
                    @click="toggleConfirmPassInputType()"
                    icon-pack="feather"
                    :icon="confirmPassInputIcon"
                  ></vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
        </div>

        <vs-button v-if="!completed"  @click="requestActivation()" color="primary" class="mr-5 mt-4">Guardar contraseña</vs-button>

        <div class="mt-base mb-6">
            <div class="text-dark" v-if="!completed">
                ¿Deseas volver a la página de inicio? <span><router-link class="bold ml-1 inline-link-primary text-dark" to="" @click.native="backToLogin">Da clic aquí.</router-link></span>
            </div>
            <div class="text-dark" v-if="completed">
                Ir a la <span><router-link class="bold ml-1 inline-link-primary text-dark" to="" @click.native="backToLogin">página de inicio.</router-link></span>
            </div>
        </div>

      </vx-card>
    </div>
  </div>
</template>

<script>
const errorMssgDef = "Ha ocurrido un error, intente más tarde.";
const successMssgDef = "Se ha activado de manera exitosa tu cuenta. Ahora puedes iniciar sesión.";
const textType = "text";
const iconEye = "icon-eye";
const iconEyeOff = "icon-eye-off";
export default {
  name: "activate-agent-account",
  props: ['token'],
  data() {
    return {
        isMounted: false,
        onError: null,
        errorMssg: errorMssgDef,
        successMssgDef: successMssgDef,
        requiredRules: 'required',
        password: null,
        passInputPassMode: true,
        confirmPassInputPassMode: true,
        completed: false,
        criteria: [false, false, false, false, false, false, false],
        colClass: "vx-col md:w-1/2 sm:w-full w-full mb-5",
        requiredPlaceholder: '(Requerido)',
        model: {
            password: null,
            confirmed_password: null,
        }
        , userInfo: null
    };
  },
  async mounted(){
    this.showLoading(true)
    await this.checkPreauth();
    this.showLoading(false)
  },
  computed: {
    passInputType() {
      return this.passInputPassMode ? "password" : textType;
    },
    passInputIcon() {
      return this.passInputPassMode ? iconEye : iconEyeOff;
    },
    confirmPassInputType(){
      return this.confirmPassInputPassMode ? "password" : textType;
    },
    confirmPassInputIcon(){
      return this.confirmPassInputPassMode ? iconEye : iconEyeOff;
    },
    passwordFieldValid(){
      return this.testPassword(this.model.password);
    },
    confirmPasswordFieldValid(){
      return this.model.password === this.model.confirmed_password && this.model.confirmed_password !=  null;
    },
  },
  methods: {
    async checkPreauth(){
        try{
            let response = await this.publicApiGet(`/api/supplier-agent/validate/${this.token}`);
            if(response.data.isValid){
                this.userInfo = response.data;
                this.isMounted = true;
            } else {
                this.backToLogin();
            }
        } catch(error){
            console.log(error);
            this.onError = true;
        }
    },
    togglePassInputType() {
      this.passInputPassMode = !this.passInputPassMode;
    },
    toggleConfirmPassInputType(){
      this.confirmPassInputPassMode = !this.confirmPassInputPassMode;
    },
    colorForCriteria(idx) {
      return this.criteria[idx] ? "text-success" : "text-danger";
    },
    iconForCriteria(idx) {
      return this.criteria[idx] ? "CheckCircleIcon" : "CircleIcon";
    },
    hasError(val){
      return this.errors.has(val);
    },
    errorText(val){
      return this.errors.first(val);
    },
    isSuccess(val){
      let ff = this.fields[val];
      return (ff && ff.required && ff.valid);
    },
    async backToLogin(){
      await this.$router.replace({name: 'login'});
    },
    async validateForm(){
      this.errorMssg = null;
      let r1 = await this.$validator.validateAll();
      if(r1){
        return this.validatePassword();
      }
      return false;
    },
    async requestActivation(){
      let ok = await this.validateForm();
      if(ok){
        await this.doRequestChange();
      }
    },
    async doRequestChange(){
      this.showLoading(true)
      try {
        const payload = {
          password: this.model.password,
          user_id: this.userInfo.uid
        };
        const res = await this.publicApiPost(`/api/supplier-agent/activate/${this.token}`, payload);
        this.completed = true;
      } catch(error) {
            console.log(error);
            this.onError = true;
            this.errorMssg = "Ha ocurrido un error, intente más tarde.";
      }
      this.showLoading(false)
    },
    validatePassword(){
      if(this.model.password !== this.model.confirmed_password){
            this.onError = true;
            this.errorMssg = "Las contraseñas no coinciden";
      }
      else {
        if(this.testPassword(this.model.password)){
          return true;
        }
        else {
            this.onError = true;
            this.errorMssg = "La contraseña no cumple los requerimientos";
        }
      }
      return false;
    },
    testPassword(pass){
      if(pass === null || pass === undefined){
        this.criteria[0] = false;
        this.criteria[1] = false;
        this.criteria[2] = false;
        this.criteria[3] = false;
        this.criteria[4] = false;
        this.criteria[5] = false;
        this.criteria[6] = false;
        return false;
      }
      //let pass = this.pw1
      const number = /.*[0-9].*/
      const lower = /.*[a-z].*/
      const upper = /.*[A-Z].*/
      const special = /.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~].*/
      const consecutive = ['abcd', 'bcde', 'cdef', 'defg', 'efgh', 'fghi', 'ghij', 'hijk', 'ijkl', 'jklm', 'klmn', 'lmnñ', 'mnño', 'nñop', 'ñopq', 'opqr', 'pqrs', 'qrst', 'rstu', 'stuv', 'tuvw', 'uvwx', 'vwxy', 'wxyz',
        '0123', '1234', '2345', '3456', '4567', '5678', '6789', '7890', '8901', '9012', '2109', '1098', '0987', '9876', '8765', '7654', '6543', '5432', '4321', '3210',
        'aaaa', 'bbbb', 'cccc', 'dddd', 'eeee', 'ffff', 'gggg', 'hhhh', 'iiii', 'jjjj', 'kkkk', 'llll', 'mmmm', 'nnnn', 'ññññ', 'oooo', 'pppp', 'qqqq', 'rrrr', 'ssss', 'tttt', 'uuuu', 'vvvv', 'wwww', 'xxxx', 'yyyy', 'zzzz',
        '1111', '2222', '3333', '5555', '6666', '7777', '8888', '9999',
        '!!!!', '""""', '####', '$$$$', '%%%%', '&&&&', '((((', '))))', '****', '++++', ',,,,', '----', '....', '////', '::::', ';;;;', '<<<<', '====', '>>>>',
        '????', '@@@@', '[[[[', ']]]]', '^^^^', '____', '````', '{{{{', '||||', '}}}}', '~~~~']

      this.criteria[0] = lower.test(pass);
      this.criteria[1] = upper.test(pass);
      this.criteria[2] = number.test(pass);
      this.criteria[3] = special.test(pass);
      this.criteria[4] = pass.length > 7;
      let no_consecutive = true
      for(let i = 0; i < consecutive.length; i ++){
        if(pass.toLowerCase().includes(consecutive[i])){
          no_consecutive = false
        }
      }
      this.criteria[5] = no_consecutive

      return (this.criteria[0] && this.criteria[1] && this.criteria[2] && this.criteria[3] && this.criteria[4] && this.criteria[5]);
    },
  },
};
</script>

<style>
</style>